/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "fuel--sprite",
  "use": "fuel--sprite-usage",
  "viewBox": "0 0 29 30",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29 30\" id=\"fuel--sprite\"><path d=\"M14.464 5.338h-8.81a1.066 1.066 0 0 0-1.066 1.066v6.867a.355.355 0 0 0 .355.355h10.232a.355.355 0 0 0 .355-.355V6.404a1.066 1.066 0 0 0-1.066-1.066Zm.356 7.574H5.299V6.404a.355.355 0 0 1 .355-.356h8.81a.355.355 0 0 1 .356.356v6.508Z\" fill=\"#232323\" stroke=\"#232323\" stroke-width=\".6\" /><path d=\"M25.204 24.401A2.8 2.8 0 0 0 28 21.61V6.283a.356.356 0 0 0-.12-.267L22.148 1l-.47.533 5.61 4.913V21.61a2.089 2.089 0 0 1-4.174 0v-9.997a2.487 2.487 0 0 0-2.487-2.487h-1.51V5.693a4.263 4.263 0 0 0-4.263-4.263H5.263A4.263 4.263 0 0 0 1 5.693v23.565a.355.355 0 0 0 .355.355h17.408a.355.355 0 0 0 .355-.355V9.835h1.51a1.776 1.776 0 0 1 1.777 1.777v9.997a2.8 2.8 0 0 0 2.8 2.792Zm-6.796 4.501H1.71V5.693A3.553 3.553 0 0 1 5.263 2.14h9.592a3.553 3.553 0 0 1 3.553 3.553v23.21Z\" fill=\"#232323\" stroke=\"#232323\" stroke-width=\".6\" /></symbol>"
});
sprite.add(symbol);
var viewBoxValues = symbol.viewBox ? symbol.viewBox.split(' ') : []

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox,
      width: viewBoxValues[2],
      height: viewBoxValues[3]
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.width = viewBoxValues[2];
SvgSpriteIcon.height = viewBoxValues[3];
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
